import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var Call = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.556 0A.555.555 0 000 .556 9.445 9.445 0 009.444 10 .555.555 0 0010 9.444V7.5a.555.555 0 00-.556-.555c-.693 0-1.36-.112-1.984-.316a.554.554 0 00-.564.136L5.673 7.989a8.378 8.378 0 01-3.66-3.659l1.222-1.226a.556.556 0 00.136-.564A6.371 6.371 0 013.055.556.555.555 0 002.5 0H.556z",
    fill: "currentColor"
  }));
});
Call.displayName = 'Call';

export { Call, Call as default };
